import { useQuery } from '@tanstack/react-query';
import fetch from './fetch';

/**
 * Fetches aggregated home portfolio summary.
 *
 * @param {object} [options]
 * @param {boolean} [options.enabled] - Control whether query should run.
 */
function useHomePortfolio(options = {}) {
  const { cb, key } = fetch();

  const query = useQuery(key, cb, {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    staleTime: 2500,
    cacheTime: 2500,
    ...options,
  });

  return query;
}

export { useHomePortfolio };
export default { useHomePortfolio };
